// extracted by mini-css-extract-plugin
module.exports = {"centeredDiv":"_6114ceb0"};